import Link from 'next/link'

const Policy = () => {
	return (
		<div className='policy-container'>
			<div className='policy-header'>
				<div className='h2'>Privacy Policy</div>
			</div>

			<div className='policy-content'>
				<div className='subheading'>Metalbook Registration Website Privacy Policy</div>
				<div className='paragraph'>
					Metalbook (Mbook Technology Private Limited) and its affiliates (collectively referred to herein as “Metalbook”, “we”, or “us”)
					respect your privacy. Here is how we collect, share, use, and protect the information we collect from or about you on this website
					(hereinafter the “Website”). All personal information, including information for Indian and non-Indian users of the Website, are
					processed by and retained on servers located in the India in accordance with Indian privacy laws. These laws may differ from the
					laws where you reside and may be less stringent.
				</div>
				<div className='subheading'>Information We Collect About You</div>
				<div className='paragraph'>
					We collect information about you from a variety of sources, including you and the device you use to access our website. Here’s how
					it works:
				</div>
				<div className='subheading'>Information You Provide to Us</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>
						We collect information that you voluntarily share with us or permit us to receive. The information we collect may include,
						among other items, the following;
					</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Your name and the name of your employer;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Your contact information, including email address, phone number and mailing address;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Information that you enter, in narrative form, into request forms or via email;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Your username and password for your account;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Timely payment of all fees, charges and other costs incurred in your use of the Website;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>The types of material you are interested in buying or selling;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Any bids or counteroffers you have made or accepted in a Metalbook auction; and</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>The addresses you provide with respect to your locations and/or the locations of your material.</div>
				</div>

				<div className='subheading'>Information We Collect Through Technology</div>
				<div className='paragraph'>
					We collect information through technology to better serve you. For example, when you visit the Website, we may collect your domain
					name, Internet Protocol (IP) address, browser version, operating system, and the website you passed through to reach our Website.
					In addition, we may track your activity within our Website.
				</div>

				<div className='subheading'>Cookies</div>
				<div className='paragraph'>
					Cookies are small files that we transfer to your computer’s hard drive through your web browser, your device, or the page you are
					viewing that enable us to recognize your browser and capture and remember certain information. We use Cookies to help us
					understand and save your preferences and to recognize you as a returning visitor.Depending on the browser you use, you may be able
					to turn off certain Cookies by adjusting your browser settings. If you do so, some of the features on the Website may be
					unavailable or may not function properly.
				</div>
				<div className='subheading'>Device Identification</div>
				<div className='paragraph'>
					We may collect the unique identification of the device(s) you use to access our Website for internal business purposes/business
					analytics.
				</div>
				<div className='subheading'>‘Do Not Track’ Browser Setting</div>
				<div className='paragraph'>
					Do Not Track (“DNT”) is a preference you can set in your browser’s settings to let the websites you visit know that you do not
					want the websites collecting your personal information. Our Website does not currently respond to DNT browser settings.
				</div>
				<div className='subheading'>Other Tracking and Information</div>
				<div className='paragraph'>
					We will not collect personal information about your online activities on other websites. However, we may use third-party tools to
					analyze Website usage, monitor performance, and prevent fraud. These tools may collect personal information about you or your
					online activities. We may also use aggregated data to improve our offerings.
				</div>
				<div className='subheading'>Google Analytics</div>
				<div className='paragraph'>
					Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data
					collected to monitor traffic and usage on our website. This data may be shared with us and with other Google services. Google may
					use the data to personalize the advertisements of its own advertising network. For more information, please see the Google privacy
					and terms website at <a href='https://policies.google.com.'>{`https://policies.google.com.`}</a>
				</div>

				<div className='subheading'> Payments</div>
				<div className='paragraph'>
					We use third-party service providers for payment processing. We will not store or collect your credit card information. Rather,
					that information is provided directly to our third-party processors, who use the information in conformance with their own privacy
					policies. Our current payment processor is Stripe. For more information, please see their privacy policy at stripe.com/privacy.
				</div>
				<div className='subheading'>Commercial Credit</div>
				<div className='paragraph'>
					We sometimes provide commercial credit through third-party credit providers. When you apply for credit with Metalbook you may be
					providing information directly to those providers, subject to their privacy policies. Our current commercial credit provider is
					Resolve. For more information, please see their privacy policy at resolvepay.com/privacy.{' '}
				</div>
				<div className='subheading'>Links to and Plug-Ins from Other Websites or Media</div>
				<div className='paragraph'>
					Our Website may from time to time include links to third-party websites or applications. We do not control any third-party sites
					or the information they collect. Third-party sites are responsible for their own privacy policies, and you enter those sites at
					your own risk.
				</div>
				<div className='subheading'>How We Use the Information We Collect About You</div>
				<div className='paragraph'>
					We use the information we collect about you to register and enroll you, to list and sell your material, to contact you, to arrange
					pickup or delivery of your material and to improve our product offering and your user experience.
				</div>
				<div className='subheading'>How We May Share Information About You</div>
				<div className='paragraph'>
					We do not sell your personal information to third parties. We may share your personal information with business associates and
					third-party service providers in order to provide services to you. We require our business associates and third-party service
					providers to safeguard your personal information in a manner consistent with this Privacy Policy.
				</div>
				<div className='subheading'>How We Protect the Information We Collect</div>
				<div className='paragraph'>
					The security and confidentiality of your personal information is important to us, and we have implemented security measures to
					protect that information from unauthorized access or disclosure. We use electronic data encryption, use servers that are kept in a
					secure, restricted area, and limit access to personal information to employees who need access to the information in order to do
					their jobs properly. Nonetheless, no security measure is failsafe, and we cannot guarantee the security of your personal
					information. To help protect your personal information, please maintain the secrecy of your login information and be sure to log
					out of our Website whenever you are not actively using it.
				</div>
				<div className='subheading'>Ownership of Information</div>
				<div className='paragraph'>
					Consistent with our Website Terms of Use, we are the sole owners of any information that you submit through the Website. We are
					not obliged to return any such materials to you at any time. We reserve the right to delete, modify, or create derivative works
					based on the information you provide.
				</div>
				<div className='subheading'>Rights Concerning Your Personally Identifiable Information</div>
				<div className='paragraph'>If you provide us with personally identifiable information, you have the right to:</div>

				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Review the personally identifiable information that you have supplied to us;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>
						Request that we correct any errors, outdated information or omissions in the personally identifiable information that you have
						supplied to us;
					</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Request that your personally identifiable information not be used to contact you;</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>
						Request that your personally identifiable information be removed from any solicitation list that we use;
					</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>Request that your personally identifiable information be deleted from our records; and/or</div>
				</div>
				<div className='listed-item'>
					<div className='checked-circle'>
						<div></div>
					</div>
					<div className='paragraph'>
						Opt out of being solicited by us.If you request that your personally identifiable information be deleted from our records,
						there may be a brief delay in our processing that request while we verify that the request is valid and originates from you as
						opposed to an unauthorized third party. If you request that your personally identifiable information be deleted, we reserve
						the right to terminate any account you have registered with us or limit your access to the Services.To exercise any of these
						rights, please contact us as set forth in this Privacy Policy.
					</div>
				</div>
				<div className='subheading'>Privacy Policy Updates</div>
				<div className='paragraph'>
					We reserve the right to change this Privacy Policy at any time without notice. Changes will be posted to this page and are
					effective immediately upon posting. You should visit this page frequently to stay informed as our Privacy Policy evolves.If we
					materially change this Privacy Policy in a way that affects how we use or disclose your personal information, we will notify you
					by prominently posting a notice of such changes on the Website before implementing them and by stating the effective date of the
					changes. Your continued use of the Website following the effective date of any such changes constitutes your full acceptance of
					those changes.
				</div>
				<div className='subheading'>Contact Information</div>
				<div className='paragraph'>
					For questions or concerns regarding our Privacy Policy, please contact us by mail at{' '}
					<Link href='mailto:contact@metalbook.co.in' target='_blank'>
						contact@metalbook.co.in.
					</Link>
				</div>
				<div className='subheading'>Governing Law and Jurisdiction</div>
				<div className='paragraph'>
					This Privacy Policy is governed by and operated in accordance with the laws of India. If any of the parties wish to seek legal
					recourse, they may do so before the courts of law in New Delhi.{' '}
				</div>
				{/* <div className="subheading">Contact Information</div> */}
			</div>
		</div>
	)
}
export default Policy
